import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=045afc23&scoped=true"
import script from "./CustomersView.vue?vue&type=script&lang=js"
export * from "./CustomersView.vue?vue&type=script&lang=js"
import style0 from "./CustomersView.vue?vue&type=style&index=0&id=045afc23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045afc23",
  null
  
)

export default component.exports